import {Type} from "../../Transaction/helper";
import { put } from 'redux-saga/effects';
import actions from "../actions";

export function* storeOriginalQuantities(transactionType, transaction) {
    switch (transactionType) {
        case Type.sale_invoice:
        case Type.sale_delivery_order:
        case Type.sale_order:
        case Type.purchase_bill:
        case Type.purchase_goods_received_note:
            break;
        default:
            return null;
    }

    const formItems = transaction?.form_items || [];

    const originalQuantities = formItems
        .filter(item => item.transfer_transaction)
        .reduce((acc, item) => [
            ...acc,
            {
                transactionId: item.transfer_transaction.id,
                transactionItemId: item.transfer_item_id,
                quantity: item.quantity,
                transferredToQuantity: Math.max(((item.quantity || 0) - (item.balance_quantity || 0)), 0),
            },
        ], []);

    yield put({
        type: actions.TXN_TRANSFER_STORE_ORIGINAL_QUANTITIES,
        originalQuantities,
    });
    return null;
}
